
export default {
  name: 'ClientsReviewsSlider',
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
    slidesPerPage: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      selectedReview: null,
      isDragging: false,
      touchStartX: 0,
      mouseStartX: 0,
      mouseStartY: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const carousel = this.$refs.carousel
      if (!carousel) return
      let dragStartPos = null
      let unlocked = false
      carousel.$el.addEventListener('mousedown', (e) => {
        dragStartPos = { x: e.pageX, y: e.pageY }
        unlocked = false
      }, true)
      const originalMove = carousel.onPointerMove
      carousel.onPointerMove = function (e) {
        if (!unlocked && dragStartPos) {
          const x = e.pageX || 0
          const y = e.pageY || 0
          if (Math.abs(x - dragStartPos.x) < 10 && Math.abs(y - dragStartPos.y) < 10) return
          unlocked = true
        }
        originalMove(e)
      }
    })
  },
  computed: {
    displayedReviews() {
      const reviewsWithMedia = this.reviews.filter(
        review =>
          review.images?.length > 0 || review.movies?.[0]?.image?.url
      )
      const maxReviews = this.$device.isMobile ? 10 : 20
      return reviewsWithMedia.slice(0, maxReviews)
    },
    shouldCenterReviews() {
      if (this.$device.isMobile || this.$device.isTablet) {
        return (
          this.displayedReviews.length > 0 && this.displayedReviews.length <= 4
        )
      }
      return (
        this.displayedReviews.length > 0 &&
        this.displayedReviews.length < this.slidesPerPage
      )
    },
    featuredsImage() {
      return function (review, srcset) {
        if (review?.movies?.[0]?.image?.url) {
          return srcset
            ? [
                `${this.$cropUrl(
                  review.movies[0].image,
                  520,
                  520,
                  review.movies[0].image.extension,
                  86
                )} 1x`,
                `${this.$cropUrl(
                  review.movies[0].image,
                  1024,
                  1024,
                  review.movies[0].image.extension,
                  86
                )} 2x`,
              ]
            : this.$cropUrl(
                review.movies[0].image,
                520,
                520,
                review.movies[0].image.extension,
                86
              )
        }
        return srcset
          ? [
              `${this.$cropUrl(
                review.images[0],
                520,
                520,
                review.images[0].extension,
                86
              )} 1x`,
              `${this.$cropUrl(
                review.images[0],
                1024,
                1024,
                review.images[0].extension,
                86
              )} 2x`,
            ]
          : this.$cropUrl(
              review.images[0],
              520,
              520,
              review.images[0].extension,
              86
            )
      }
    },
  },
  methods: {
    onDragStart() {
      this.isDragging = true
    },
    onDragEnd() {
      setTimeout(() => {
        this.isDragging = false
      }, 50)
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.isDragging = false
    },
    onTouchEnd(e, review) {
      const touchEndX = e.changedTouches[0].clientX
      const diff = Math.abs(touchEndX - this.touchStartX)
      if (diff < 10 && !this.isDragging) {
        this.selectedReview = review
        this.$bvModal.show('modalReview')
      }
    },
    onMouseDown(e) {
      this.mouseStartX = e.clientX
      this.mouseStartY = e.clientY
    },
    onMouseUp(e, review) {
      const diffX = Math.abs(e.clientX - this.mouseStartX)
      const diffY = Math.abs(e.clientY - this.mouseStartY)
      if (diffX < 50 && diffY < 50) {
        this.selectedReview = review
        this.$nextTick(() => {
          this.$bvModal.show('modalReview')
        })
      }
    },
    openReviewModal(review) {
      this.selectedReview = review
      this.$bvModal.show('modalReview')
    },
  },
}
